export default class PendingMAPAttempt
{
	id = null
	submittedOn = null

	userId = null
	userName = null
	
	rocketId = null
	flightId = null
}